import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { AdvisoryFeeModule } from '@ddt-web/advisory-fee';
import { AnalyticsModule } from '@ddt-web/analytics';
import { SharedModule } from '@ddt-web/common';
import { DataServiceModule } from '@ddt-web/data-service';
import { DisclosureModule } from '@ddt-web/disclosure';
import { GenericPipesModule } from '@ddt-web/generic-utils';
import { PerformanceModule } from '@ddt-web/performance';
import { SecuritiesTableModule } from '@ddt-web/securities-table';
import { CombinedDataTableModule } from '@ddt-web/table';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { FamilyFooterModule } from '../family-footer/family-footer.module';
import { FamilyPerformanceComponent } from './family-performance.component';
import { PerformanceTableComponent } from './performance-table';
import { PerformanceTableSkeletonComponent } from './performance-table/performance-table-skeleton/performance-table-skeleton.component';

@NgModule({
	declarations: [FamilyPerformanceComponent, PerformanceTableComponent, PerformanceTableSkeletonComponent],
	imports: [
		AnalyticsModule,
		SharedModule,
		GenericPipesModule,
		CommonModule,
		CwpNgFrameworkModule,
		DisclosureModule,
		RouterModule.forChild([
			{ path: '', pathMatch: 'full', component: FamilyPerformanceComponent }
		]),
		DataServiceModule,
		NgxSkeletonLoaderModule,
		FamilyFooterModule,
		SecuritiesTableModule,
		PerformanceModule,
		CombinedDataTableModule,
		AdvisoryFeeModule
	]
})
export class FamilyPerformanceModule { }
